module.exports = __webpack_public_path__ + "img/fuji_half.6b511b76.svg";